<template>
  <AppModal heading="Cancel Order Request" @close="$emit('close')">
    <div slot="content">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
          >
            <input
              class="form-input"
              type="text"
              placeholder="Reason for Cancellation"
              name="Reason for Cancellation"
              v-model="formData.reason_for_cancellation"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <select
              class="form-input focus:text-opacity-100"
              :class="{'text-dark text-opacity-50': !formData.issue_title}"
              v-model="formData.refund_required"
              name="Refund Required"
            >
              <option value="" disabled>Refund Required</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" :rules="isRefundRequired">
            <input
              class="form-input"
              type="number"
              placeholder="Amount to refund"
              name="Amount to refund"
              v-model="formData.refund_amount_requested"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <textarea
              class="w-full border border-dark-b rounded-lg p-3 h-48"
              placeholder="Additional Notes"
              name="Additional Notes"
              v-model="formData.additional_notes"
            />
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <button class="new-app-btn bg-blue mt-1">Submit</button>
        </form>
      </ValidationObserver>
    </div>
  </AppModal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'CancelOrderModal',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        reason_for_cancellation: '',
        refund_required: '',
        refund_amount_requested: '',
        additional_notes: ''
      }
    }
  },
  computed: {
    isRefundRequired() {
      return this.formData.refund_required === '1' ? 'required' : ''
    }
  },
  methods: {
    ...mapActions ([
      'cancelOrder'
    ]),
    async onSubmit() {
      const response = await this.cancelOrder({
        id: this.order.orderInformation.id,
        formData: this.formData
      })

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
      this.$emit('close')
    }
  }
}
</script>
